/// <reference path="./mixpanel-browser.d.ts"/>
import * as mixpanel from 'mixpanel-browser';
import {ITracker} from './base-tracker';
import {IExperimentMap} from '../experiments';
import {WHITE_LABEL, WHITE_LABEL_EMAIL_VERIFIED} from '../config';
import {isAudioVideoUnsupported} from '../helpers';

const audioVideoSupported = !isAudioVideoUnsupported();
export class MixpanelTracker implements ITracker {
  private prefixExperiments: {[name: string]: string|boolean};

  constructor(token: string, host: string, userId: string, experiments: IExperimentMap) {
    mixpanel.init(token, {
        api_host: host,
        autotrack: false,
        track_pageview: false,
        disable_notifications: true,
        loaded: () => {
        if (userId) {
          mixpanel.identify(userId);
          mixpanel.register({whiteLabel: WHITE_LABEL});
          mixpanel.register({whiteLabelEmailVerified: WHITE_LABEL_EMAIL_VERIFIED});
        }
      },
    });

    this.prefixExperiments = {};
    Object.keys(experiments).forEach((experiment) => {
      this.prefixExperiments['exp_' + experiment] = experiments[experiment].group;
    });
  }

  public track = (event: string, data: any = {}, fn?: () => void): void => {
    // we are tracking experiments as part of events, and not as super properties, to not overload the cookie.
    mixpanel.track(event, {...data, ...this.prefixExperiments, audioVideoSupported}, fn);
  };

  public getDistinctId = (): string => {
    return mixpanel.get_distinct_id();
  }
}
